import React from "react";
import { useEffect, useState, useRef } from "react";
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from "../utils/constants";
import moment from "moment";
import StepHeader from "../screens/registration/stepHeader";
import TabComponent from "./TabComponent";
import AdminDrawer from "./admin_module_drawer.js";
import AdminMobileDrawer from "./admin_module_mobile_drawer.js";
import ChangePassword2 from "../screens/user_login_auth/changePassword2";
import NetworkStatusIndicator from "./NetworkStatusIndicator";
import Modal from "react-modal";
import { goToVendorPage, openVendorDownloadCentre } from "../utils/vendorNavigation";
import HeaderInfoTiles, { readSessionList } from "./HeaderInfoTiles";
import MobileInfoPanel, { MobileAccountCard } from "./MobileInfoPanel";

const HeaderWithLogo = ({ changeSummaryPage }) => {
  const history = useNavigate();
  const navigate = useNavigate();

  const navigateTo = (page) => {
    if (changeSummaryPage) {
      changeSummaryPage(page);
    } else {
      goToVendorPage(navigate, page);
    }
  };
  const [isLoading, setLoader] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileMenuOpen2, setMobileMenuOpen2] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [isChangePasswordOpen, setChangePasswordOpen] = useState(false);
  const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
  const notificationRef = useRef(null);
  const marqueeRef = useRef(null);
  const loadScripts = () => {
    // Your existing script loading logic
  };

  useEffect(() => {
    loadScripts();
    console.log(
      "Exhibition Logo---------------------->",
      sessionStorage.getItem("ExhibitionLogoSS")
    );
  }, []);

  const onLogoutClick = () => {
    localStorage.clear();
    navigate("/");
  };

  const openPdf = () => {
    var URL = userManualDownloadUrl;
    window.open(URL, null);
  };

  // true when the info panel was opened from ☰ (Team Members): no notifications card there
  const [isInfoOnlyPanel, setInfoOnlyPanel] = useState(false);

  const toggleMobileMenu = () => {
    setInfoOnlyPanel(false);
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleInfoPanel = () => {
    setInfoOnlyPanel(true);
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileMenu2 = () => {
    setMobileMenuOpen2(!isMobileMenuOpen2);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const closeMobileMenu2 = () => {
    setMobileMenuOpen2(false);
  };

  // Exhibition From Date
  const dateString = sessionStorage.getItem("exhibitionDateFrom");
  const dateStringMoment = moment
    .utc(dateString, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject = new Date(dateStringMoment);
  const fromDay = dateObject.getDate();
  const fromMonth = dateObject.toLocaleString("default", { month: "long" });
  const fromYear = dateObject.getFullYear();
  const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;

  // Exhibition to Date
  const dateString1 = sessionStorage.getItem("exhibitionDateTo");
  const dateString1Moment = moment
    .utc(dateString1, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject1 = new Date(dateString1Moment);
  const toDay = dateObject1.getDate();
  const toMonth = dateObject1.toLocaleString("default", { month: "long" });
  const toYear = dateObject1.getFullYear();
  const toDate = `${toDay} ${toMonth} ${toYear}`;

  // Exhibition Address
  const address = sessionStorage.getItem("ExhibitionAddressSS");

  // Logo URLs
  const exhibitionLogo = sessionStorage.getItem("ExhibitionLogoSS");
  const mainLogo = sessionStorage.getItem("MainLogoSS") || "../images/Logo_3.png";

  // Exhibition Dates
  const exhibitionFromDate = sessionStorage.getItem("ExhibitionFromDateSS");
  const exhibitionToDate = sessionStorage.getItem("ExhibitionToDateSS");

  // Profile and User Details
  const profileName = (sessionStorage.getItem("profileNameSS") || "").toUpperCase();
  const nameParts = profileName.split(' ').filter(Boolean);
  const initials = nameParts.length > 0 ? (nameParts[0][0] + (nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '')).toUpperCase() : '';
  const roleID = sessionStorage.getItem("RoleIDSS");

  // Corporate Link
  const corporateLink = sessionStorage.getItem("CorporateLinkSS") || "https://corporate.india-itme.com";


  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // ✅ Force-close mobile menus when switching to desktop
      if (!mobile) {
        setMobileMenuOpen(false);
        setMobileMenuOpen2(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Run once on mount to sync state
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  return (
    <>
      {isLoading ? <Loader></Loader> : null}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}


      {/* Mobile Sidebar Menu */}
      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        {/* Same rules as before:
            - Team Members' ☰ panel (isInfoOnlyPanel): no name bar / notifications, just a close button
            - Team Members' 👤 panel: name + notifications only (details and account live in ☰)
            - Account card for everyone except vendors (they have it in their ☰ menu) */}
        {(() => {
          const showDetails = roleID != 20 || isInfoOnlyPanel
          return (
            <MobileInfoPanel
              name={profileName}
              onClose={closeMobileMenu}
              compactHead={isInfoOnlyPanel}
              notifications={!isInfoOnlyPanel ? notifications : undefined}
              onNotificationClick={(n) => { openPreview(n.id); closeMobileMenu(); }}
              onMarkAllRead={markAllRead}
              onViewAll={() => { openDrawer(); closeMobileMenu(); }}
              details={showDetails ? {
                dates: `${exhibitionFromDate || ''} - ${exhibitionToDate || ''}`,
                location: address,
                rows: [{ icon: 'fa-external-link', label: 'Corporate Site', value: <a href={corporateLink} target="_blank" rel="noopener noreferrer">Visit the corporate site</a> }],
              } : undefined}
              assistance={showDetails ? { phones: readSessionList('sessionExhibitionMobileNo'), emails: readSessionList('sessionExhibitionEmail') } : undefined}
            >
              {showDetails && roleID != 7 && roleID != 17 && (
                <MobileAccountCard
                  onChangePassword={() => { closeMobileMenu(); setChangePasswordOpen(true); }}
                  onSignOut={() => { closeMobileMenu(); setIsLogoutModalOpen(true); }}
                />
              )}
            </MobileInfoPanel>
          )
        })()}
      </div>

      {isMobileMenuOpen2 && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu2}
        ></div>
      )}

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen2 && (
        <>

          {/* Mobile Tabs Sidebar */}
          <div className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen2 ? "mobile-menu-open" : ""
            }`}>
            <div style={{ height: '100%', overflowY: 'hidden', position: 'relative', backgroundColor: '#3dbca7' }}>
              <button
                onClick={closeMobileMenu2}
                className="text-white position-absolute"
                style={{ top: '10px', right: '15px', background: 'transparent', border: 'none', fontSize: '36px', lineHeight: '1', padding: '0', zIndex: 1000 }}
              >
                ×
              </button>
              <div className="admin-menu-list-wrapper">
                {sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ? (
                  <ul className="side-menu w-100 text-start text-left" style={{ marginRight: '0px', padding: '0', marginTop: '40px', listStyle: 'none' }}>
                    <div className="user-section mb-2 mt-4" style={{ padding: '0 20px' }}>
                      <h6 className="text-uppercase text-white fw-bold m-0">
                        {(() => {
                          try {
                            const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
                            const first = (loginData.FirstName || '').trim();
                            const last = (loginData.LastName || '').trim();
                            let displayName = first;
                            if (last && first && first.split(/\s+/).pop().toLowerCase() !== last.toLowerCase()) {
                              displayName = `${first} ${last}`;
                            } else if (!first) {
                              displayName = last;
                            }
                            const initials = first ? `(${first.charAt(0).toUpperCase()}${last ? last.charAt(0).toUpperCase() : ''})` : '';
                            return `${displayName} ${initials}`.trim() || sessionStorage.getItem("profileNameSS");
                          } catch (e) {
                            return sessionStorage.getItem("profileNameSS");
                          }
                        })()}
                      </h6>
                    </div>
                    <li className="slide mobile-list">
                      <a className="side-menu__item has-link d-flex align-items-center" style={{ cursor: 'pointer', padding: '5px 20px', color: 'white' }} onClick={() => { navigateTo('VendorRegistrationAU'); closeMobileMenu2(); }}>
                        <i className="fa fa-user-circle-o me-3" style={{ fontSize: '18px', width: '20px' }}></i>
                        <span className="side-menu__label" style={{ fontSize: '15px' }}>Profile</span>
                      </a>
                    </li>
                    <li className="slide mobile-list">
                      <a className="side-menu__item has-link d-flex align-items-center" style={{ cursor: 'pointer', padding: '5px 20px', color: 'white' }} onClick={() => { navigateTo('VendorWorkOrderList'); closeMobileMenu2(); }}>
                        <i className="fa fa-clipboard me-3" style={{ fontSize: '18px', width: '20px' }}></i>
                        <span className="side-menu__label" style={{ fontSize: '15px' }}>Scope of Work</span>
                      </a>
                    </li>
                    <li className="slide mobile-list">
                      <a className="side-menu__item has-link d-flex align-items-center" style={{ cursor: 'pointer', padding: '5px 20px', color: 'white' }} onClick={() => { navigateTo('EntryPass'); closeMobileMenu2(); }}>
                        <i className="fa fa-sign-in me-3" style={{ fontSize: '18px', width: '20px' }}></i>
                        <span className="side-menu__label" style={{ fontSize: '15px' }}>Material Entry Pass</span>
                      </a>
                    </li>
                    <li className="slide mobile-list">
                      <a className="side-menu__item has-link d-flex align-items-center" style={{ cursor: 'pointer', padding: '5px 20px', color: 'white' }} onClick={() => { navigateTo('ExitPass'); closeMobileMenu2(); }}>
                        <i className="fa fa-sign-out me-3" style={{ fontSize: '18px', width: '20px' }}></i>
                        <span className="side-menu__label" style={{ fontSize: '15px' }}>Material Exit Pass</span>
                      </a>
                    </li>
                    <li className="slide mobile-list">
                      <a className="side-menu__item has-link d-flex align-items-center" style={{ cursor: 'pointer', padding: '5px 20px', color: 'white' }} onClick={() => { openVendorDownloadCentre(navigate); closeMobileMenu2(); }}>
                        <i className="fa fa-download me-3" style={{ fontSize: '18px', width: '20px' }}></i>
                        <span className="side-menu__label" style={{ fontSize: '15px' }}>Download Center</span>
                      </a>
                    </li>
                    {/* Account actions in their own white card (same as the other ☰ panels), apart from the page links */}
                    <li className="vendor-menu-account">
                      <MobileAccountCard
                        onChangePassword={() => { setChangePasswordOpen(true); closeMobileMenu2(); }}
                        onSignOut={() => { closeMobileMenu2(); setIsLogoutModalOpen(true); }}
                      />
                    </li>
                  </ul>
                ) : (
                  <AdminMobileDrawer />
                )}
              </div>
            </div>

            {/* <TabComponent
              tabs={MOBILE_TABS}
              activeTab={activeTab}
              onTabChange={(tab) => {
                handleTabChange(tab);
                closeMobileMenu2();
              }}
              onSpecialClick={() => {
                closeMobileMenu2();
              }}
              isMobile
            /> */}
          </div>
        </>
      )}

      {/* app-Header */}
      <div className="app-header header sticky app-heder-with-logo mb-4 exhibitor-header pt-1 visitor-header-light">
        {/* desktop: 8px on the right so the icon circles sit close to the edge */}
        <div className="container-fluid main-container px-2 ps-md-3 pe-md-2">
          <div className="header-content-wrapper exhibitor-header-wrapper d-flex align-items-center justify-content-between w-100 py-2">
            {/* Logo Section */}
            <div className="side-header top-logo-almnt d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
              <a className="header-brand1" href="index.html" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', padding: '4px 8px' }}>
                {exhibitionLogo && (
                  <img
                    src={exhibitionLogo}
                    className="header-brand-img light-logo m-0"
                    alt="logo"
                    style={{ height: "76px", maxWidth: "100%", objectFit: 'contain' }}
                  />
                )}
                {mainLogo && (
                  <img
                    src={mainLogo}
                    className="header-brand-img m-0"
                    alt="main logo"
                    style={{ height: "76px", maxWidth: "100%", objectFit: 'contain' }}
                  />
                )}
              </a>
            </div>

            {/* Left Aligned Exhibition Details: plain text on tablets */}
            <div className="exhibitor-content-left flex-grow-1 mx-3 d-none d-md-block d-xl-none">
              <div className="exhibitor-event-info">
                <h5 className="exhibitor-event-dates mb-0 text-white" style={{ fontSize: '14px' }}>
                  {exhibitionFromDate} - {exhibitionToDate}
                </h5>
                <p className="exhibitor-event-address mb-0" style={{ fontSize: '12px' }}>{address}</p>
              </div>
            </div>

            {/* Desktop: shared icon-tile details */}
            <HeaderInfoTiles
              fromDate={exhibitionFromDate}
              toDate={exhibitionToDate}
              address={address}
              mobiles={readSessionList('sessionExhibitionMobileNo')}
              emails={readSessionList('sessionExhibitionEmail')}
            />

            {/* Desktop Profile - Hidden on mobile */}
            <div className="desktop-profile exhibitor-desktop-profile d-none d-lg-block">
              {/* hdr-actions: network, corporate site, bell and profile are the same white circle */}
              <div className="dropdown profile-1 exhibitor-profile-dropdown hdr-actions d-flex align-items-center mt-2">
                {/* Network Connectivity: signal bars only (status in the tooltip / legend),
                    so the right side leaves room for the assistance details */}
                <NetworkStatusIndicator compact />

                {/* Corporate Site: icon button, name on hover */}
                <a
                  href={corporateLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hdr-icon-btn"
                  title="Corporate Site"
                  aria-label="Corporate Site"
                >
                  <i className="fa fa-globe"></i>
                </a>

                {/* NOTIFICATION BELL */}
                <div className="notification-bell-wrapper me-3" ref={notificationRef}>
                  <i
                    className="fa fa-bell hdr-icon-btn"
                    onClick={() => setShowNotifications(!showNotifications)}
                    title="Notifications"
                  ></i>
                  {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                  {showNotifications && (
                    <div className="notification-dropdown shadow">
                      <div className="notification-dropdown-header">
                        <span>Notifications</span>
                        {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                      </div>
                      {notifications.length === 0 ? (
                        <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                      ) : notifications.slice(0, 3).map(n => (
                        <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                          <span className={`notification-item-icon ${n.type}`}>
                            {n.initial}
                          </span>
                          <div className="notification-item-content" style={{ flex: 1 }}>
                            <div className="notification-item-title">{n.title}</div>
                            <NotificationMeta notification={n} />
                            {n.time && <div className="notification-item-time">{n.time}</div>}
                          </div>
                          <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                        </div>
                      ))}
                      <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                    </div>
                  )}
                </div>
                {sessionStorage.getItem("RoleIDSS") != 7 && sessionStorage.getItem("RoleIDSS") != 17 && (
                  <>
                    <a
                      href="javascript:void(0)"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="exhibitor-profile-trigger"
                    >
                      <span className="user-in exhibitor-profile-name hdr-profile-btn">
                        {profileName}
                      </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow exhibitor-dropdown-menu">
                      <div className="exhibitor-dropdown-header">
                        <div className="exhibitor-dropdown-user">
                          {profileName}
                        </div>
                      </div>
                      <li className="dropdown-item p-2 hover-bg-light" style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <button
                          onClick={() => { setChangePasswordOpen(true); }}
                          className="text-dark d-flex align-items-center bg-transparent border-0 w-100 text-start"
                          style={{ padding: '8px 12px', fontSize: '14px', textDecoration: 'none' }}
                        >
                          <i className="fa fa-lock me-2" style={{ color: '#3dbca7', width: '16px' }}></i> Change Password
                        </button>
                      </li>
                      <div className="exhibitor-dropdown-divider"></div>
                      <a
                        className="dropdown-item exhibitor-dropdown-item exhibitor-logout-item"
                        onClick={() => onLogoutClick()}
                      >
                        <i
                          className="fa fa-sign-out exhibitor-dropdown-icon"
                          aria-hidden="true"
                        ></i>
                        Sign out
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Mobile Right Icons - Wrapped to stick to the right edge */}
            <div className="mobile-right-icons d-flex ms-auto d-lg-none pe-1 hdr-actions">
              {/* Mobile Network Connectivity */}
              <NetworkStatusIndicator compact />



              {/* Mobile Toggle Button */}
              <div className="mobile-toggle exhibitor-mobile-toggle">
                <button
                  onClick={toggleMobileMenu}
                  className="exhibitor-menu-toggle-btn text-white" style={{ padding: '3px' }}>
                  <span className="material-symbols-outlined">
                    person
                  </span>
                </button>
              </div>

              {/* Hamburger Menu Toggle */}
              {/* (roleID == 2 || roleID == 5 || roleID == 6 || roleID == 4 || roleID == 8 || roleID == 17 || roleID == 1) && */}
              {roleID == 16 && roleID == 25 && (
                <div className="mobile-toggle exhibitor-mobile-toggle">
                  <button
                    // Team Members (role 20) have no menu pages: ☰ opens the info panel
                    // (exhibition details, Change Password, Sign out) instead
                    onClick={roleID == 20 ? toggleInfoPanel : toggleMobileMenu2}
                    className="exhibitor-menu-toggle-btn"
                  >
                    <span className="exhibitor-menu-toggle-bar"></span>
                    <span className="exhibitor-menu-toggle-bar"></span>
                    <span className="exhibitor-menu-toggle-bar"></span>
                  </button>
                </div>
              )}
            </div>

          </div>

          {/* Absolute Marquee at the bottom of the header */}
          <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              ref={marqueeRef}
              onMouseOver={() => marqueeRef.current?.stop()}
              onMouseOut={() => marqueeRef.current?.start()}
              style={{ pointerEvents: 'auto', marginBottom: '0' }}
            >
              <b>Disclaimer and Ownership:</b> {disclaimer}
            </marquee>
          </div>
        </div>
      </div>
      {/* /app-Header */}
      <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
      <NotificationPreviewModal notification={previewItem} onClose={closePreview} />

      {isChangePasswordOpen && (
        <ChangePassword2 onClose={() => setChangePasswordOpen(false)} />
      )}

      {/* Logout Confirmation Modal */}
      <Modal isOpen={isLogoutModalOpen} onRequestClose={() => setIsLogoutModalOpen(false)}>
        <div className="modal-dialog custom_modal_dialog modal-dialog-centered" style={{ maxWidth: '350px' }}>
          <div className="modal-content" style={{ borderRadius: '8px', border: 'none', overflow: 'hidden' }}>
            <div style={{ backgroundColor: '#3dbca7', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h6 style={{ color: 'white', margin: 0, fontWeight: '600', fontSize: '15px' }}>Confirm Logout</h6>
              <button onClick={() => setIsLogoutModalOpen(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', lineHeight: '1', padding: 0, cursor: 'pointer' }}>&times;</button>
            </div>
            <div style={{ padding: '30px 24px', textAlign: 'center' }}>
              <div style={{ width: '56px', height: '56px', backgroundColor: 'rgba(60, 187, 167, 0.15)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto' }}>
                <i className="fa fa-user-circle-o" style={{ color: '#3dbca7', fontSize: '28px' }}></i>
              </div>
              <h5 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '24px', fontSize: '16px' }}>Do you really want to logout?</h5>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button onClick={() => { setIsLogoutModalOpen(false); onLogoutClick(); }} className="btn" style={{ backgroundColor: '#3dbca7', color: 'white', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Log Out
                </button>
                <button onClick={() => setIsLogoutModalOpen(false)} className="btn" style={{ backgroundColor: '#9ca3af', color: 'white', border: 'none', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%' }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default HeaderWithLogo;
